<div [class]="rootClass()" role="status" aria-live="polite" [attr.aria-label]="message()">
    @if (isSpinner()) {
        <i class="pi pi-spin pi-spinner rbi-loading-state__spinner" aria-hidden="true"></i>
        @if (message()) {
            <p class="rbi-loading-state__message">{{ message() }}</p>
        }
    } @else if (isCards()) {
        <div class="rbi-loading-state__cards">
            @for (item of items(); track item) {
                <div class="rbi-loading-state__card">
                    <span class="rbi-loading-state__bar rbi-loading-state__bar--short"></span>
                    <span class="rbi-loading-state__bar rbi-loading-state__bar--block"></span>
                </div>
            }
        </div>
    } @else {
        <div class="rbi-loading-state__rows">
            @for (item of items(); track item) {
                <div class="rbi-loading-state__row">
                    @for (column of columns; track column) {
                        <span class="rbi-loading-state__bar"></span>
                    }
                </div>
            }
        </div>
    }
</div>
